import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const emojiDropdown = style({
  backgroundColor: vars.color.white,
  borderRadius: vars.buttons.radius,
  boxShadow: vars.shadow,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.1em',
  overflow: 'auto',
  padding: '0.4rem',
  position: 'relative'
})

export const emojiButton = style({
  alignItems: 'center',
  background: 'none',
  border: 'none',
  display: 'flex',
  aspectRatio: '1 / 1',
  transition: 'background-color 0.2s',

  ':hover': {
    backgroundColor: vars.color.light
  }
})

export const emojiButtonSelected = style({
  backgroundColor: vars.color.light
})

export const emojiImage = style({
  width: '1em',
  height: '1em'
})
